import { type PaymentMethod } from '@constants'
import { type Campaign } from '@hooks-api/types/dataModel/campaigns'
import { type OrderItem } from '@hooks-api/types/dataModel/fpOrder'
import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import { type ApplePayPaymentTokenPaymentData } from '../../types/applePay'

export type CartItems = Record<string, Record<string, OrderItem>>

type CartBundles = Record<string, {
  qty: number
  amount: number
}>

const loadSessionStorage = (key: string) => {
  try {
    const data = window.sessionStorage.getItem(key)

    if (!data) {
      return null
    }

    return JSON.parse(data)
  }
  catch (error) {
    console.error(error)
    return null
  }
}
/**
 * @deprecated
 */
export const clientSlice = createSlice({
  name: 'clientContents',
  initialState: {
    projectCode: null as string | null,
    fastpassProductsData: null as Fastpass.FastPassProductResponse | null,
    exhibitorSettings: null as Campaign | null,
    currentParentProduct: 0,
    cartItems: JSON.parse(window.sessionStorage.getItem('cartItems') || '{}') as CartItems,
    countCartItems: parseInt(window.sessionStorage.getItem('countCartItems') || '0'),
    cartTotal: 0,
    shippingFee: 0,

    cartBundles: {} as CartBundles,
    enabledBundles: [] as string[],
    discount: 0,
    orderHash: null as null | string,
    orderID: null as null | number,
    paymentMethod: null as null | PaymentMethod,
    offlinePaymentUrlData: null as null | Fastpass.PaymentUrl,
    currentOrder: null as null | Fastpass.Order,
    isGiveawayDispatch: false,
    invoiceInfo: {
      receipt_type: 'non_business_einvoice',
      phone_carrier_number: '',
      business_ubn_title: '',
      business_ubn: '',
      refund_statement: true,
    },
    gifts: loadSessionStorage('gifts') as Record<number, string> | null,
    shouldShowGuidance: false,
    category: '',
    applePayPaymentData: null as ApplePayPaymentTokenPaymentData | null,
  },
  reducers: {
    setProjectCode: (state, action) => {
      state.projectCode = action.payload
    },
    setFastpassProductsData: (state, action) => {
      state.fastpassProductsData = action.payload
    },
    setExhibitorSettings: (state, action: PayloadAction<Campaign>) => {
      state.exhibitorSettings = action.payload
    },
    setCurrentParentProduct: (state, action) => {
      state.currentParentProduct = action.payload
    },
    // setCarItems: (
    //   state,
    //   action: {
    //     type: string,
    //     payload: Variation & { qty: number },
    //   }
    // ) => {
    //   const { cartItems } = state
    //   const variation = action.payload

    //   const key = `${variation.project_code}-${variation.product_id}`

    //   cartItems[key] = cartItems[key] || {}
    //   cartItems[key][variation.variation_id] = variation

    //   if (variation.qty === 0) {
    //     delete cartItems[key][variation.variation_id]
    //   }

    //   if (Object.keys(cartItems[key]).length === 0) {
    //     delete cartItems[key]
    //   }

    //   state.cartItems = cartItems
    //   const { enabledBundles, discount } = CartUtil.getDiscount(
    //     cartItems,
    //     state.fastpassProductsData?.bundles || {}
    //   )

    //   // TODO 不應該再 action 裏面呼叫其他 action 來更改 state
    //   clientSlice.caseReducers.setCountCartItems(state)
    //   clientSlice.caseReducers.setShippingFee(state)
    //   clientSlice.caseReducers.setEnabledBundles(state, {
    //     type: 'setEnabledBundles',
    //     payload: enabledBundles,
    //   })

    //   clientSlice.caseReducers.setDiscount(state, {
    //     type: 'setDiscount',
    //     payload: discount,
    //   })
    //   clientSlice.caseReducers.setCartTotal(state)

    //   window.sessionStorage.setItem('cartItems', JSON.stringify(cartItems))
    // },

    // setCountCartItems: (state) => {
    //   const countCartItems = Object.values(state.cartItems).reduce((acc, cur) => {
    //     return (
    //       acc +
    //       Object.values(cur).reduce((acc, cur) => {
    //         return acc + cur.qty
    //       }, 0)
    //     )
    //   }, 0)
    //   state.countCartItems = countCartItems
    //   window.sessionStorage.setItem('countCartItems', countCartItems + '')
    // },

    // setCartTotal: (state) => {
    //   const { cartItems } = state

    //   const cartTotal = Object.values(cartItems).reduce((acc, cur) => {
    //     return (
    //       acc +
    //       Object.values(cur).reduce((acc, cur) => {
    //         return acc + cur.sale_price * cur.qty
    //       }, 0)
    //     )
    //   }, 0)

    //   state.cartTotal = cartTotal + state.shippingFee - state.discount
    // },

    // setShippingFee: (state) => {
    //   const cartItems = state.cartItems
    //   const products = CartUtil.flatCartItems(cartItems)

    //   if (!state.fastpassProductsData) {
    //     state.shippingFee = 0
    //     return
    //   }

    //   const { discountByDelivery } = CartUtil.getDiscount(
    //     cartItems,
    //     state.fastpassProductsData?.bundles || {}
    //   )

    //   state.shippingFee = CartUtil.getShippingFee(
    //     products,
    //     state.fastpassProductsData?.delivery || {},
    //     discountByDelivery as Record<Fastpass.DeliveryType, number> | undefined
    //   )
    // },

    setEnabledBundles: (state, action) => {
      const { payload } = action as { type: string, payload: string[] }
      payload.sort()

      if (JSON.stringify(state.enabledBundles) === JSON.stringify(payload)) {
        return
      }
      state.enabledBundles = payload
    },

    setDiscount: (state, action) => {
      const decimals = state.exhibitorSettings?.decimal ?? 2

      state.discount = parseFloat(action.payload.toFixed(decimals))
    },

    setOrderID: (state, action) => {
      state.orderID = action.payload
    },

    setOrderHash: (state, action) => {
      state.orderHash = action.payload
    },

    setPaymentMethod: (state, action) => {
      state.paymentMethod = action.payload
    },

    setOfflinePaymentUrlData: (state, action) => {
      state.offlinePaymentUrlData = action.payload
    },

    setCurrentOrder: (state, action) => {
      state.currentOrder = action.payload
    },

    setApplePayPaymentData: (state, action: { type: string, payload: ApplePayPaymentTokenPaymentData | null }) => {
      state.applePayPaymentData = action.payload
    },

    // setCartEmpty: (state) => {
    //   const cartItems = CartUtil.flatCartItems(state.cartItems) as (Variation & { qty: number })[]

    //   cartItems.forEach((item) => {
    //     clientSlice.caseReducers.setCarItems(state, {
    //       type: 'setCountCartItems',
    //       payload: { ...item, qty: 0 },
    //     })
    //   })
    // },
    setInvoice: (state, action) => {
      state.invoiceInfo = { ...state.invoiceInfo, ...action.payload }
    },

    setIsGiveawayDispatch: (state, action: { type: string, payload: boolean }) => {
      state.isGiveawayDispatch = action.payload
    },
    setGifts: (state, action: { type: string, payload: Record<number, string> }) => {
      state.gifts = { ...state.gifts, ...action.payload }
      window.sessionStorage.setItem('gifts', JSON.stringify(state.gifts))
    },
    setShouldShowGuidance: (state, action) => {
      state.shouldShowGuidance = action.payload
    },
    setCategory: (state, action) => {
      state.category = action.payload
    },
  },
})

export const {
  setCurrentParentProduct,
  setProjectCode,
  setFastpassProductsData,
  setExhibitorSettings,
  setOrderHash,
  setOrderID,
  setPaymentMethod,
  setOfflinePaymentUrlData,
  setCurrentOrder,
  setInvoice,
  setIsGiveawayDispatch,
  setGifts,
  setShouldShowGuidance,
  setCategory,
  setApplePayPaymentData,
} = clientSlice.actions
export default clientSlice.reducer
